import gsap from 'gsap';
import Utils from '../utils/utils';
import emitter from 'tiny-emitter/instance';

/**
 *
 */
class Menu {

  /**
   *
   * @param options
   */
  constructor() {

    Utils.debug('Construct menu');

    this.menuOpen = false;
    this.$menu = document.querySelector('.main-menu')
    this.$btn = document.querySelector('.main-menu__btn')
    this.$content = document.querySelector('.main-menu__content')
    this.$navbar = document.querySelector('.navbar')
    this.TL_menu = false;
    this.init();
    this.bindEvents()
  }

  /**
   * Init
   */
  init() {
    Utils.debug('Init menu');

    let self = this;

    emitter.on('openSearchBar',()=>{
      self.close();
    })

    self.$btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!self.menuOpen) {
        self.open();
      } else {
        self.close();
      }
    })
  }

  bindEvents() {

    emitter.on('barba::after', () => {
      if(Utils.desktopBurger()){
        this.close()
      }
    })

    window.addEventListener('resize', (evt) => {
      if (window.innerWidth >= 1220) {
        gsap.set(
          '.navbar-social',
          {clearProps: 'all'}
        ),

          gsap.set(
            '.navbar-menu',
            {clearProps: 'all'}
          )

        gsap.set(
          '.navbar-search',
          {clearProps: 'all'}
        ),

          gsap.set(
            '.navbar-language',
            {clearProps: 'all'}
          )
      }
    })
  }


  /**
   * Open
   */
  open() {

    Utils.debug('Menu:Open');

    let self = this;
    self.menuOpen = true;
    self.$menu.classList.add('main-menu_open');
    self.$btn.classList.add('main-menu__btn_open');

    // gsap.set('.navbar-menu',{autoAlpha:0, display:'none'})
    // gsap.set('.navbar-social',{autoAlpha:0, display:'none'})
    // gsap.set('.navbar-search',{autoAlpha:0, display:'none'})
    // gsap.set('.navbar-language',{autoAlpha:0, display:'none'})

    if (self.TL_menu) self.TL_menu.pause();
    self.TL_menu = new gsap.timeline();
    self.TL_menu.add([
      self.$navbar.classList.add('menu-open'),


      gsap.to('.main', {xPercent: -20, duration: 1.5, ease: 'expo.inOut'}),

      gsap.fromTo(
        '.navbar-search',
        {xPercent: -40, autoAlpha: 0},
        {delay: .7, duration: 1.5, xPercent: 0, display: 'flex', autoAlpha: 1, ease: 'expo.out'}
      ),
      gsap.fromTo(
        '.navbar-language',
        {xPercent: -40, autoAlpha: 0},
        {delay: .7, duration: 1.5, xPercent: 0, display: 'flex', autoAlpha: 1, ease: 'expo.out'}
      ),

      gsap.fromTo(
        '.navbar-social',
        {xPercent: -40, autoAlpha: 0},
        {delay: .7, duration: 1.5, xPercent: 0, display: 'flex', autoAlpha: 1, ease: 'expo.out'}
      ),

      gsap.fromTo(
        '.navbar-menu',
        {xPercent: -40, autoAlpha: 0},
        {delay: .7, duration: 1.5, xPercent: 0, display: 'flex', stagger: {each: 0.15}, autoAlpha: 1, ease: 'expo.out'}
      ),

      gsap.fromTo(self.$content, {translateX: '100%'}, {duration: 1.5, translateX: '0%', ease: 'expo.inOut'}),

    ]);


  }


  /**
   * Close
   */
  close() {

    Utils.debug('Menu:Close');


    let self = this;
    self.menuOpen = false;
    self.$menu.classList.remove('main-menu_open');
    self.$btn.classList.remove('main-menu__btn_open');
    self.$menu.classList.add('menu-close');

    if (self.TL_menu) self.TL_menu.pause();
    self.TL_menu = new gsap.timeline();
    self.TL_menu.add([

      gsap.to('.main', {xPercent: 0, delay: 0.3, duration: 1.5, ease: 'expo.inOut'}),

      gsap.to(
        '.navbar-search',
        {
          duration: 0.5, autoAlpha: 0, ease: 'expo.out', onComplete: () => {
            self.$navbar.classList.remove('menu-open');
          }
        }
      ),
      gsap.to(
        '.navbar-language',
        {duration: 0.5, autoAlpha: 0, ease: 'expo.out'}
      ),

      gsap.to(
        '.navbar-social',
        {duration: 0.5, autoAlpha: 0, ease: 'expo.out'}
      ),

      gsap.to(
        '.navbar-menu',
        {duration: 0.5, stagger: {each: 0.15}, autoAlpha: 0, ease: 'expo.out'}
      ),

      gsap.fromTo(self.$content, {translateX: '0%'}, {
        duration: 1.5,
        delay: 0.3,
        translateX: '100%',
        ease: 'expo.inOut'
      }),

    ]);

  }
}


//module.exports = Menu;
export default Menu;



// WEBPACK FOOTER //
// ./scripts/interface/menu.js